/**
 * Token Management Utilities
 * Handles token retrieval, validation, and expiration checks
 */
import md5 from 'blueimp-md5';

const PUBLIC_FRAGMENTS = ['/s/', '/external/', '/confirmAccount'];

export const cSharpTicksToMilliseconds = (ticks) => {
  const seconds = ticks / 10_000_000; // 10M ticks per second
  return seconds * 1000; // 1000ms per second
};

export const isPublicFragment = () => {
  return PUBLIC_FRAGMENTS.some((fragment) => window.location.href.includes(fragment));
};

export const generateTokenKey = (global = false) => {
  if (isPublicFragment() && !global && !window.location.href.includes('authorize')) {
    const search = window.location.search;
    const code = search.split('=').pop();

    const type = search.includes('publicCode=') ? 'public' : 'external';
    const id = search.includes('publicCode=') ? code : md5(code);

    return `${type}Token"${id}"`;
  }

  return 'token';
};

export const getToken = ({ global = false } = {}) => {
  const tokenKey = generateTokenKey(global);
  const token = localStorage.getItem(`x-auth-${tokenKey}`);
  try {
    return JSON.parse(token);
  } catch (e) {
    return false;
  }
};

export const isTokenExpired = ({ global = false } = {}) => {
  const token = getToken({ global });
  if (!token) return true;

  const issuedMilliseconds = cSharpTicksToMilliseconds(token.issued);
  const expiresInMilliseconds = token.expiresIn * 1000;
  const expirationTime = issuedMilliseconds + expiresInMilliseconds;
  const currentTime = Date.now();

  return currentTime > expirationTime;
};

/**
 * Remove specific token from localStorage
 * @param {string} type - Token type (public/external)
 * @param {string} id - Token identifier
 */
export const removeTokenById = (type, id) => {
  localStorage.removeItem(`x-auth-${type}Token"${id}"`);
  localStorage.removeItem(`x-${type}-processId"${id}"`);
  localStorage.removeItem(`x-${type}-processInstance"${id}"`);
};
